import Component from '../abstracts/Component';
import FixBody from '../utils/FixBody';
import TrackingComponent from '../components/TrackingComponent';

export default class PdpImagesComponent extends Component {

  constructor(htmlEl) {
    super(htmlEl);
    this.zoomTriggers = this.$component.querySelectorAll(this.SELECTORS.zoomTrigger);
    this.navigationTriggers = this.$component.querySelectorAll(this.SELECTORS.navigationTrigger);
    this.zoomContainer = this.$component.querySelector(this.SELECTORS.zoomContainer);
    this.zoomImage = this.$component.querySelector(this.SELECTORS.zoomImage);
    this.zoomClose = this.$component.querySelector(this.SELECTORS.zoomClose);
    this.zoomNavigation = this.$component.querySelector(this.SELECTORS.zoomNavigation);
    this.zoomPrevArrow = this.$component.querySelector(this.SELECTORS.zoomPrevArrow);
    this.zoomNextArrow = this.$component.querySelector(this.SELECTORS.zoomNextArrow);
    this.productCarousel = this.$component.querySelector(this.SELECTORS.productCarousel);
    this.carouselPrevArrow = this.$component.querySelector(this.SELECTORS.carouselPrevArrow);
    this.carouselNextArrow = this.$component.querySelector(this.SELECTORS.carouselNextArrow);
    this.thumbnailsNav = this.$component.querySelector(this.SELECTORS.thumbnailsNav);
    this.nav = this.$component.querySelector(this.SELECTORS.nav);
    this.imagesWrapper = this.$component.querySelector(this.SELECTORS.imagesWrapper);
    this.imageCount = this.$component.querySelector(this.SELECTORS.zoomImageCount);
    this.loader = this.$component.querySelector(this.SELECTORS.loader);
    this.activePicture = null;
    this.TrackingComponent = new TrackingComponent();
    this.heightFit = true;
    this.activePosition = 1;

    this.galleryOptions = {
      prevArrow: this.carouselPrevArrow,
      nextArrow: this.carouselNextArrow,
      slidesToShow: 1,
      infinite: true,
      variableWidth: true,
      // adaptiveHeight: true,
      focusOnSelect: true,
      lazyLoad: 'progressive',
      speed: 300,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            variableWidth: false,
            adaptiveHeight: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            variableWidth: false,
            adaptiveHeight: false,
          }
        }]
    };

    this.thumbnailsOptions = {
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: this.SELECTORS.productCarousel,
      dots: false,
      arrows: false,
      centerMode: false,
      focusOnSelect: true,
      vertical: true,
      verticalSwiping: true,
      infinite: true,
      speed: 0,
    }
  }

  get COMPONENTNAME() {
    return 'PdpImagesComponent';
  }

  get SELECTORS() {
    return {
      zoomTrigger: '[data-zoom-trigger]',
      zoomContainer: '[data-zoom-container]',
      zoomImage: '[data-zoom-image-selected]',
      zoomClose: '[data-trigger-close]',
      navigationTrigger: '[data-navigation-trigger]',
      productCarousel: '[data-js-product-carousel]',
      carouselPrevArrow: '[data-prev-arrow]',
      carouselNextArrow: '[data-next-arrow]',
      zoomNavigation: '[data-zoom-navigation]',
      zoomPrevArrow: '[data-zoom-prev-arrow]',
      zoomNextArrow: '[data-zoom-next-arrow]',
      thumbnailsNav: '.js-thumbnails-nav',
      zoomImageCount: '.js-zoom-count',
      loader: '.js-loader',
      imagesWrapper: '.js-images-wrapper',
      nav: '.js-nav'
    };
  }

  get CLASSES() {
    return {
      HEIGHT_FIT: 'height-fit',
      ACTIVE: '--active',
      HIDDEN: '--hidden',
      ZOOM_OPEN: '--zoom-open',
      INVISIBLE: '--invisible',
      FADEIN_ANIMATION: '--fadein-opacity'
    }
  }

  // MOBILE CAROUSEL //
  importSlick() {

    if (this.thumbnailsNav) {
      this.galleryOptions.asNavFor = this.SELECTORS.thumbnailsNav;
    }

    this.moduleLoader.loadCarouselAndExecute(
      module => {
        //initializing slick
        const $carousel = $(this.productCarousel);
        $carousel.on("init", (event, slick) => {
          // this.$emit(this.$customEvents.CAROUSEL.init, {}, this.productCarousel);
          // //slick.slickGoTo(0);
          // this.imagesWrapper.classList.add(this.CLASSES.FADEIN_ANIMATION);
          // this.nav.classList.add(this.CLASSES.FADEIN_ANIMATION);
          // this.thumbnailsNav.classList.add(this.CLASSES.FADEIN_ANIMATION);
          // this.loader.classList.add(this.CLASSES.HIDDEN);
        });
        //
        $carousel.on("lazyLoaded", (event, slick , image) => {
          // if there is prevObject.length is 1 I am in the last image loaded
          if (image.prevObject.length === 1) {
            this.$emit(this.$customEvents.CAROUSEL.init, {}, this.productCarousel);
            this.imagesWrapper.classList.add(this.CLASSES.FADEIN_ANIMATION);
            this.nav.classList.add(this.CLASSES.FADEIN_ANIMATION);
            this.thumbnailsNav.classList.add(this.CLASSES.FADEIN_ANIMATION);
            this.loader.classList.add(this.CLASSES.HIDDEN);
          }
        });

        $carousel.slick(this.galleryOptions);

        ['.pdp__images__buttons', '.pdp__zoom__container'].forEach(container => {
          $(`${container} .chevron-left-button`).on('click', () => {
            this.TrackingComponent.actions.zoomLayer('change', 'prev');
          });
          $(`${container} .chevron-right-button`).on('click', () => {
            this.TrackingComponent.actions.zoomLayer('change', 'next');
          });
        });

        if (this.thumbnailsNav) {
          $(this.thumbnailsNav).slick(this.thumbnailsOptions);
        }
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  /**
   * Closes the zoom view for product images.
   * This method performs the following actions:
   * - Unblocks the body scrolling
   * - Hides the zoom container
   * - Removes the active state from the currently active picture
   * - Resets the active picture reference
   * - For mobile devices, destroys the slick carousel for zoom navigation
   * - Emits closeZoomMobile event on mobile devices
   * - Emits closeZoom event in all cases
   */
  closeZoom() {
    FixBody.unblock();
    this.TrackingComponent.actions.zoomLayer('close');
    this.zoomContainer.classList.add(this.CLASSES.HIDDEN);
    this.activePicture ? this.activePicture.classList.remove(this.CLASSES.ACTIVE) : '';
    this.activePicture = null;
    document.body.classList.remove(this.CLASSES.ZOOM_OPEN);
    if (window.matchMedia('(max-width: 768px)').matches) {
      $(this.zoomNavigation).slick('unslick');
    }
    this.$emit(this.$customEvents.PDP_LAYER_EVENTS.closeZoom);
  }

  // open image zoom //
  openZoom(image) {
    FixBody.block();
    this.zoomContainer.classList.remove(this.CLASSES.HIDDEN);
    this.TrackingComponent.actions.zoomLayer('open');
    this.zoomImage.style.backgroundImage = `url(${image.dataset.zoomImage})`;
    this.zoomImage.classList.add(this.CLASSES.HEIGHT_FIT);
    const activePicture = this.$component.querySelector('.pdp__zoom__container [data-navigation-index="' + image.dataset.index + '"]');

    this.activePosition = (parseInt(image.dataset.index) + 1);
    this.imageCount.innerText = `${this.activePosition}/${this.imageCount.dataset.count}`;

    document.body.classList.add(this.CLASSES.ZOOM_OPEN);

    if (activePicture) {
      const image = activePicture.querySelector('img');
      image.classList.add(this.CLASSES.ACTIVE);
      this.activePicture = image;
    }
    this.$emit(this.$customEvents.PDP_LAYER_EVENTS.openZoom);
  }

  openZoomMobile(imageIndex) {
    FixBody.block();
    this.zoomContainer.classList.remove(this.CLASSES.HIDDEN);
    this.TrackingComponent.actions.zoomLayer('open');
    const options = {
      mobileFirst: true,
      prevArrow: this.zoomPrevArrow,
      nextArrow: this.zoomNextArrow,
      lazyLoad: 'progressive',
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    };
    $(this.zoomNavigation).slick(options);
    this.$emit(this.$customEvents.PDP_LAYER_EVENTS.openZoom);
  }

  clickOnNavigationCard(image) {
    this.activePicture ? this.activePicture.classList.remove(this.CLASSES.ACTIVE) : '';
    this.zoomImage.style.backgroundImage = `url(${image.dataset.zoomImage})`;
    const activePicture = image.querySelectorAll('img')[0];
    activePicture.classList.add(this.CLASSES.ACTIVE);
    this.activePicture = activePicture;
    this.TrackingComponent.actions.zoomLayer('change', image.dataset.navigationIndex);

    this.activePosition = (parseInt(image.dataset.navigationIndex) + 1);
    this.imageCount.innerText = `${this.activePosition}/${this.imageCount.dataset.count}`;
  }

  handleMouseMove() {
    this.zoomImage.onmousemove = ({clientY}) => {
      if (typeof clientY !== 'number') {
        console.warn('image-zoom mouse event failed');
        return 0;
      }
      const perc = (clientY / window.innerHeight) * 100;
      const mousePositionPerc = Math.min(Math.max(perc, 0), 100);
      this.zoomImage.style.backgroundPositionY = mousePositionPerc + "%";
    };

    this.zoomImage.addEventListener("click", (event) => {
      //TODO check if is not mobile
      this.zoomImage.classList.toggle(this.CLASSES.HEIGHT_FIT);

    })
  }

  bindEvents() {


    Promise.all(Array.from(document.images).filter(img => !img.complete).map(img => new Promise(resolve => {
      img.onload = img.onerror = resolve;
    }))).then(() => {
      // console.log('images finished loading');
    });


    // handle mouse move on desktop
    if (this.zoomImage && window.matchMedia('(min-width: 768px)').matches) {
      this.handleMouseMove();
    }
    if (this.zoomTriggers) {
      this.zoomTriggers.forEach(image => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          // desktop behaviour
          image.addEventListener("click", this.openZoom.bind(this, image));
        } else {
          //mobile behaviour
          image.addEventListener("click", this.openZoomMobile.bind(this, image.dataset.index));
        }

      });
    }
    if (this.navigationTriggers && window.matchMedia('(min-width: 768px)').matches) {
      this.navigationTriggers.forEach(image => {
        image.addEventListener("click", this.clickOnNavigationCard.bind(this, image));
      });
    }
    if (this.zoomClose) {
      this.zoomClose.addEventListener("click", (event) => {
        this.closeZoom();
      });
    }

    this.$on(this.$customEvents.PDP_LAYER_EVENTS.triggerCloseZoom, () => {
      this.closeZoom();
    });
  }

  render() {
    super.render();
    this.importSlick();
    this.bindEvents();
  }
}
